import AOS from "aos";
import "aos/dist/aos.css";

import "jquery-timepicker/jquery.timepicker.css";
import "jquery-timepicker/jquery.timepicker";
import { compileString } from "sass";
import { set } from "lodash";

import Swiper from "swiper";

jQuery(($) => {
	AOS.init({ disable: "mobile" });

	$(window).on("load", function () {
		AOS.refresh();
	});
	/****************** CLOSE SITE-ALERT ******************/

	$(".alert-message").on("click", ".close-icon", () => {
		setCookie("SITE_ALERT", "closed", 7, true);
		$("#wrapper").removeClass("alert-shown");
		$("#site-alert").removeClass("is-active");
		console.log("Site alert closed");
	});

	/****************** POPUP ******************/

	let popit = 0;
	let popClicked = 0;

	if ($(".more-link").length > 0) {
		$(".more-link").on("click", function () {
			$(".col-right").hide();
			$(".col-left").addClass("active");

			$(".col-more").toggleClass("active");
			$(".more-link").hide();
			$(".more-link-close").show();
		});

		$(".more-link-close").on("click", function () {
			$(".col-more").toggleClass("active");
			$(".more-link").show();
			$(".more-link-close").hide();

			$(".col-right").show();
			$(".col-left").removeClass("active");
		});
	}

	if ($(".popup").length > 0) {
		$(".popup-button, .close-popup-icon").on("click", function () {
			popit++;

			const classList = $(this).attr("class").split(" ");
			$(`#${classList[1]}`).toggleClass("show");
			$("body").addClass("is--popped");

			popClicked = 1;
		});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(".popup-interior-copy").length &&
				popit >= 1 &&
				popClicked != 1
			) {
				if ($(".popup.show").is(":visible")) {
					$(".disclaimer").fadeOut();
					$(".popup.show").removeClass("show");
					$("body").removeClass("is--popped");
					console.log("clicked");
					popit = 0;
				}
			} else {
				popClicked = 0;
			}
		});
	}

	/****************** TOOLTIP HOVER ******************/

	let tool = 0;
	let justClicked = 0;

	if (window.innerWidth < 1024) {
		$(".info-icon").on("click", function () {
			tool++;
			$(".disclaimer").removeClass("active").fadeOut();
			$(this).siblings(".disclaimer").fadeIn("active");
			justClicked = 1;
		});

		if ($(".tooltip-container.disclaimer").length > 0) {
			$(document).on("click", function (e) {
				if (
					!$(e.target).next(".disclaimer").length &&
					tool >= 1 &&
					justClicked != 1
				) {
					if ($(".tooltip-container.disclaimer").is(":visible")) {
						$(".disclaimer").fadeOut();
						tool = 0;
					}
				} else {
					justClicked = 0;
				}
			});
		}
	}

	/**/

	if (window.innerWidth > 1023) {
		$(".info-icon")
			.on("mouseenter", handlerIn)
			.on("mouseleave", handlerOut);

		function handlerIn() {
			$(this).siblings(".disclaimer").fadeIn();
		}

		function handlerOut() {
			$(this).siblings(".disclaimer").fadeOut();
		}
	}

	/****************** CHANGE DATEPICKER ICON ******************/

	if ($(".ui-datepicker-trigger").length > 0) {
		$(".ui-datepicker-trigger").attr(
			"src",
			"/wp-content/themes/showcase/assets/dist/images/datepicker.svg"
		);
	}

	/****************** HAMBURGERS MENU ******************/

	$("#header").on("click", "button.navbar-toggler", function () {
		$(this).toggleClass("is-active");
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
	});

	$(".mobile-menu li a").on("click", function () {
		$("main#main").toggleClass("is--open");
		$("nav#header").toggleClass("menu-open");
		$("body").toggleClass("is--open");
		$("button.navbar-toggler").toggleClass("is-active");
	});

	/****************** HAMBURGERS MENU DROPDOWN ******************/

	$(".mobile-menu li.dropdown").on("click", function () {
		$(this).toggleClass("active");
	});

	/****************** HIDE NAVBAR WHEN SCROLLING ******************/

	let didScroll;
	let st;
	const $sideBar = $(".side-bar");
	const $spacer = $(".spacer");

	/****************** STICKY SIDE ******************/

	$(window).on("resize scroll", function () {
		didScroll = true;
		st = $(window).scrollTop();

		if ($sideBar.length > 0) {
			if (st >= $(".spacer").offset().top + $spacer.outerHeight()) {
				$sideBar.addClass("sticky-side");
			} else {
				$sideBar.removeClass("sticky-side");
			}
		}
	});

	let lastScrollTop = 0;
	const delta = 5;
	//const $body = $("body");
	const $header = $("#header");
	const $showHeader = $("#show-header");
	//const $sitealert = $("#site-alert");
	const navbarHeight = $showHeader.outerHeight();

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 0); //350

	function hasScrolled() {
		if (st === 0) {
			/* $header.removeClass("expanded-header");
			$sitealert.removeClass("expanded-header"); */

			$header.removeClass("no-show");
			$showHeader.removeClass("giddy-up");

			lastScrollTop = st;
			return;
		}

		if (Math.abs(lastScrollTop - st) <= delta) return;

		if (st >= 0 && st >= navbarHeight) {
			$showHeader.addClass("giddy-up");
			$header.addClass("no-show");
		}
		/* if (st < navbarHeight) {

		} */

		/* if (st > lastScrollTop && st > navbarHeight) {
			$header.removeClass("expanded-header").addClass("nav-up");
			$sitealert.removeClass("expanded-header").addClass("nav-up");
			$body.addClass("nav-sticky");
		} else {
			if (st < navbarHeight) {
				$header.removeClass("expanded-header");
				$sitealert.removeClass("expanded-header");
				$body.removeClass("nav-sticky");
			} else if (st + $(window).height() < $(document).height()) {
				$header.removeClass("nav-up").addClass("expanded-header");
				$sitealert.removeClass("nav-up").addClass("expanded-header");
				$body.addClass("nav-sticky");
			}
		} */

		lastScrollTop = st;
	}

	/* $(window).on("scroll", () => {
		if ($(window).scrollTop() === 0) {
			console.log("scroll top");
			$body.removeClass("nav-sticky");
			$("#header").removeClass("nav-up expanded-header");
		}
	}); */

	/****************** MOBILE DROPDOWN ******************/
	/* if (window.innerWidth < 1024) {
		if ($(".services-dropdown").length > 0) {
			$(".services-dropdown").on("click", function () {
				$(this).toggleClass("nav-is-visible");
			});

			$("#services-dropdown").on("change", function () {
				// Get the selected option's value
				console.log($(this).val());
				var selectedUrl = $(this).val();

				// Check if a valid URL is selected
				if (selectedUrl) {
					// Redirect to the selected URL
					window.location.href = selectedUrl;
				}
			});
		}
	} */

	const swiperTabs = new Swiper(".swiper-menu-tabs", {
		loop: false,
		init: false,
		centeredSlides: true,
		roundLengths: true,
		slideToClickedSlide: true,
		spaceBetween: 15,
		slidesPerView: "auto",
	});

	if ($(".swiper-menu-tabs").length > 0) {
		if ($(window).width() < 1200) {
			initSlick();
		}

		$(window).on("resize", function () {
			if ($(window).width() < 1200) {
				initSlick();
			} else {
				destroySlick();
			}
		});

		function initSlick() {
			console.log("initSlick");
			swiperTabs.init();
		}
		function destroySlick() {
			console.log("destroySlick");
			swiperTabs.destroy();
		}
	}

	if ($(".menu-tabs-interior").length > 0) {
		let clickedAction = false;
		let animationTimeout;
		let whoClicked;

		$(window).on("resize scroll", () => {
			const scrollPos = $(window).scrollTop();
			const windowHeight = $(window).height();
			const footerTop = $("footer").offset().top;
			const breadcrumbs = $("#breadcrumbs").height() ?? 0;

			const realPosition =
				$(".menu-city-changer").offset().top +
				$(".menu-city-changer").outerHeight();

			if (
				scrollPos >= realPosition &&
				scrollPos + windowHeight < footerTop
			) {
				$(".menu-tabs-interior").addClass("sticky-side");
			} else {
				if ($(window).width() > 1099) {
					$(".menu-tabs-interior").removeClass("sticky-side");
				} else {
					if (
						scrollPos >= realPosition &&
						scrollPos + breadcrumbs < footerTop
					) {
						$(".menu-tabs-interior").removeClass("sticky-side");
					} else {
						if (whoClicked) {
							if (!whoClicked.is(":first-child")) {
								$(".menu-tabs-interior").removeClass(
									"sticky-side"
								);
							} else {
								if (
									whoClicked.is(":first-child") &&
									scrollPos < realPosition
								) {
									$(".menu-tabs-interior").removeClass(
										"sticky-side"
									);
								}
							}
						} else {
							$(".menu-tabs-interior").removeClass("sticky-side");
						}
					}
				}
			}
		});

		$(".menu-tabs-interior li").on("click", function () {
			$(".menu-tabs-interior li").removeClass("active");
			$(this).addClass("active");
			const target = $(this).attr("class").split(" ")[0];

			whoClicked = $(this);

			let targetTop = $(`#${target}.menu-sections`).offset().top - 160;

			if ($(window).width() < 1200) {
				targetTop =
					$(`#${target}.menu-sections`).offset().top + 106 + 110;

				if ($(window).width() < 768) {
					targetTop =
						$(`#${target}.menu-sections`).offset().top - 110;
				}
			}

			clickedAction = true;

			if (animationTimeout) clearTimeout(animationTimeout);

			$("html, body").animate({ scrollTop: targetTop }, "fast", () => {
				animationTimeout = setTimeout(() => {
					clickedAction = false;
				}, 500);
			});
		});

		const observer = new IntersectionObserver(
			(entries) => {
				if (clickedAction) {
					return;
				}

				let activeSet = false;

				entries.forEach((entry) => {
					const id = entry.target.id;
					if (entry.isIntersecting && !activeSet) {
						$(`.menu-tabs-interior li`).removeClass("active");
						$(`.menu-tabs-interior .${id}`).addClass("active");

						const slideIndex = $(`#${id}`).index();
						swiperTabs.slideTo(slideIndex);

						activeSet = true;
					}
				});
			},
			{
				root: null,
				rootMargin: "0px",
				threshold: 0.5, //50% of the element is visible
			}
		);

		$(".menu-content .menu-sections").each(function () {
			observer.observe(this);
		});
	}

	// To the top
	$("#to-top").on("click", function () {
		$("html, body").animate({ scrollTop: 0 }, "fast");
	});

	// Anchor links

	if ($("body.happenings").length > 0) {
		let hash = window.location.hash;

		if (hash) {
			hash = hash.split("/")[0];

			$("#specials").addClass("hidden");
			$("#specials-selector").addClass("hidden");
			$("#blog").addClass("hidden");
			$("#events").addClass("hidden");

			$("#tab-specials").removeClass("active");
			$("#tab-blog").removeClass("active");
			$("#tab-events").removeClass("active");

			$(hash).removeClass("hidden");
			const removeHash = hash.replace("#", "");
			$(`#tab-${removeHash}`).addClass("active");
			$(`.tabs-loop #tab-${removeHash}`).prop("selected", true);

			if (hash === "#specials") {
				$("#specials-selector").removeClass("hidden");
			}
		}
	}

	/// To the top
	const $toTop = $("#to-top");
	const $footer = $("footer");

	$(window).on("resize scroll", () => {
		const scrollTop = $(window).scrollTop();
		const windowHeight = $(window).height();
		const footerOffsetTop = $footer.offset().top;
		const scrollBottom = scrollTop + windowHeight;

		if (scrollTop > 100) {
			$toTop.removeClass("hidden");
		} else {
			$toTop.addClass("hidden");
		}

		if (scrollBottom >= footerOffsetTop) {
			$toTop.addClass("on-footer");
		} else {
			$toTop.removeClass("on-footer");
		}
	});

	$toTop.on("click", () => {
		$("html, body").animate({ scrollTop: 0 }, fast);
		return false;
	});

	//Timepicker
	if ($(".timePickerInput input").length > 0) {
		$(".timePickerInput input").timepicker({
			timeFormat: "h:mm p",
			minTime: "10",
			maxTime: "11:30pm",
		});
	}

	//// Book
	if ($(`#book-location`).length > 0) {
		$(`#book-location`).on("change", function () {
			const selectedLocation = $(this).val();
			const classes = $(this).attr("class").split(" ");

			/* $(".booking-form.attractions").removeClass("hidden");
			$(".booking-form.attractions").addClass("active"); */

			if (classes[0] === "locale-attractions") {
				$("#attractions").prop("disabled", false);

				$("#booking-content .btn").removeClass("parties");
				$("#booking-content .btn").addClass("attractions");

				if (selectedLocation == "rockwall") {
					$("#attractions.greenville").addClass("hidden");
					$("#attractions.greenville").removeClass("active");
					$("#attractions.rockwall").removeClass("hidden");
					$("#attractions.rockwall").addClass("active");
				} else if (selectedLocation == "greenville") {
					$("#attractions.rockwall").addClass("hidden");
					$("#attractions.rockwall").removeClass("active");
					$("#attractions.greenville").removeClass("hidden");
					$("#attractions.greenville").addClass("active");
				}
			} else if (classes[0] === "locale-parties") {
				$("#party-type").prop("disabled", false);

				$("#booking-content .btn").addClass("parties");
				$("#booking-content .btn").removeClass("attractions");

				if (selectedLocation == "rockwall") {
					$("#party-type").removeClass("greenville");
					$("#party-type").addClass("rockwall");
				} else if (selectedLocation == "greenville") {
					$("#party-type").addClass("greenville");
					$("#party-type").removeClass("rockwall");
				}
			}
		});

		$("#booking-content .btn").on("click", function () {
			const selectedLocation = $("#book-location").val();
			const selectedAttraction = $(
				"#attractions.rockwall, #attractions.greenville, #party-type.rockwall, #party-type.greenville"
			).val();

			const attraction = selectedAttraction.split(" ")[0];
			const selectedTypes = $("#booking-content .btn")
				.attr("class")
				.split(" ");

			$.ajax({
				dataType: "html",
				url: ajax_posts.ajaxurl,
				type: "POST",
				data: {
					action: "get_acf_fields",
					location: selectedLocation,
					field: attraction,
					selectedType: selectedTypes[2],
				},
				success: function (response) {
					const data =
						typeof response === "string"
							? JSON.parse(response)
							: response;
					if (data.success) {
						if (data.data.script_url) {
							window.location.href = data.data.script_url;
						} else if (data.data.open_url) {
							window.location.href = data.data.open_url;
						} else if (data.data.escapology) {
							$("#grayedout").removeClass("hidden");
						} else if (data.data.error) {
							console.error(data.data.error);
						} else {
							console.error("Unexpected response format:", data);
						}
					} else {
						console.error(
							"Success flag not set in response:",
							data
						);
					}
				},
				error: function (error) {
					console.log("Error:", error);
				},
			});
		});

		$(".btn.cancel").on("click", function () {
			$("#grayedout").addClass("hidden");
		});
	}

	function loadScriptIntoIframe(scriptUrl, iframeId) {
		const iframe = document.getElementById("booking-html");

		if (!iframe) {
			console.error(`Iframe with ID ${iframeId} not found`);
			return;
		}

		console.log("Before iframe onload");
		iframe.contentWindow.document.body.appendChild(script);

		iframe.onload = () => {
			console.log("Iframe loaded");

			iframe.srcdoc = "";

			const script = document.createElement("script");
			script.src = scriptUrl + "?v=" + Date.now();
			script.type = "text/javascript";

			script.onload = () => {
				console.log("Script loaded");
			};

			script.onerror = () => {
				console.error("Error loading script:", scriptUrl);
			};
		};
	}
});

/* function getClosestLowerHalfHour() {
	const now = new Date();
	const minutes = now.getMinutes();

	// Determine the closest lower half-hour
	const roundedMinutes = minutes < 30 ? 0 : 30;
	now.setMinutes(roundedMinutes, 0, 0); // Set to closest lower 00 or 30 minutes

	const options = {
		timeZone: "America/Chicago",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	};

	const timeInChicago = new Intl.DateTimeFormat("en-US", options).format(now);
	return timeInChicago;
} */

function setCookie(name, value, days, secure = false) {
	if (!name || typeof name !== "string") {
		console.error("Invalid cookie name:", name);
		return;
	}

	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}

	const encodedValue = encodeURIComponent(value || "");
	document.cookie = `${name}=${encodedValue}${expires}; path=/; SameSite=Strict${secure ? "; Secure" : ""}`;
}

function getCookie(name) {
	if (!name || typeof name !== "string") {
		console.error("Invalid cookie name:", name);
		return null;
	}

	const nameEQ = `${name}=`;
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1);

		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
	}

	return null;
}

function deleteCookie(name, secure = false) {
	if (!name || typeof name !== "string") {
		console.error("Invalid cookie name:", name);
		return;
	}

	document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict${secure ? "; Secure" : ""}`;
}

function checkCookie(cookieName) {
	const cookieValue = getCookie(cookieName);

	if (cookieValue !== null) {
		console.log("Cookie found:", cookieValue);
		return true;
	} else {
		console.log("Cookie not found");
		return false;
	}
}
